export class InvoicesRequest{
    user: string;
    s_ins: number;
    start_dt: string;
    end_dt: string;

    constructor(user: string, s_ins: number, start_dt: string, end_dt: string){
        this.user = user;
        this.s_ins = s_ins;
        this.start_dt = start_dt;
        this.end_dt = end_dt;
    }
}